import React, { useEffect, useState } from "react";
import Loading from "../../../../loading/Loading";
import "./StandardTemplatesList.scss";
import { CommonEnums } from "../../../../../enums/common.enums";
import VidioIcon from "../../../../../components/icons/VidioIcon";
import RightArrowIcon from "../../../../../components/icons/RightArrowIcon";
import LeftArrowIcon from "../../../../../components/icons/LeftArrowIcon";
import toast from "react-hot-toast";
import { TemplatesApi } from "../../../../../utils/api/Templates";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import { useSearchParams } from "react-router-dom";
import { getImageUrl } from "../../../../../utils/helpers/common";
import RoundTrueIcon from "../../../../../components/icons/RoundTrueIcon";
import PreviewModal from "../../../workspace/propertypost/view/PreviewModal";
import { Modal } from "@mui/material";
import DownloadIcon from "../../../../../components/icons/DownloadIcon";
import PreviewCircleIcon from "../../../../../components/icons/PreviewCircleIcon";

interface stateType {
  isLoading: boolean;
  listData: any[];
  totalPage: number;
  pageNumber: number;
}

const AgencyPersonalizedTemplatesList = ({
  selectedId,
  selectedAnnouncementSlug,
  postType,
}: {
  selectedId: string;
  selectedAnnouncementSlug?: string;
  postType: string;
}) => {
  const [state, setState] = useState<stateType>({
    isLoading: false,
    listData: [],
    totalPage: 1,
    pageNumber: 1,
  });
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingSelection, setPendingSelection] = useState<any>(null);

  const [searchParams] = useSearchParams();
  let type: any = searchParams?.get("type");
  let subscription_type: any = searchParams?.get("subscription_type");
  let listing_type: any = searchParams?.get("listing_type");

  const [rawApiData, setRawApiData] = useState<any[]>([]);

  const template_id = useSelector(
    (state: RootState) => state?.templates?.selectedTemplateId,
  );

  const selectedTemplateIds = useSelector(
    (state: RootState) => state.templates.selectedTemplateIds,
  );

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImages, setPreviewImages] = useState<string[]>([]);

  const announcementSlugs = [
    "announcement_for_sale_image_post",
    "announcement_for_sale_story_post",
  ];
  const isMultiSelectMode = announcementSlugs.includes(template_id);

  const checkImagetype = (type: string) => {
    switch (type) {
      case CommonEnums?.postType?.image_post?.key:
        return "image-post-template";
      case CommonEnums?.postType?.video_post?.key:
        return "video-post-template";
      case CommonEnums?.postType?.story_post?.key:
        return "stroy-post-template";
      case CommonEnums?.postType?.reel_post?.key:
        return "reel-post-template";
      default:
        return "template-image";
    }
  };

  const checkVideo = (type: string) =>
    [
      CommonEnums?.postType?.video_post?.key,
      CommonEnums?.postType?.reel_post?.key,
    ].includes(type);

  const onClickPreview = () => {
    setState((prev) => ({
      ...prev,
      pageNumber: prev.pageNumber - 1,
    }));
  };

  const onClickNext = () => {
    setState((prev) => ({
      ...prev,
      pageNumber: prev.pageNumber + 1,
    }));
  };

  const getListApi = async (page: number) => {
    setState((prev) => ({ ...prev, isLoading: true }));

    const payload: any = {
      page,
      // template_type_id: template_id,
      post_type: postType,
      // listing_type,
      // subscription_type,
    };

    if (isMultiSelectMode && selectedAnnouncementSlug) {
      payload.announcement_type = selectedAnnouncementSlug;
    }

    const res = await TemplatesApi.getAgencyPersonalizedTemplates(payload);

    if (res?.data?.success) {
      setRawApiData(res.data.data.docs);
      setState((prev) => ({
        ...prev,
        isLoading: false,
        totalPage: res.data.data.totalPages,
      }));
    } else {
      setState((prev) => ({ ...prev, isLoading: false }));
      toast.error(res?.data?.message);
    }
  };

  useEffect(() => {
    getListApi(state.pageNumber);
  }, [state.pageNumber, template_id, selectedAnnouncementSlug]);

  useEffect(() => {
    const updatedList = rawApiData.map((template: any) => ({
      ...template,
      // selected: isMultiSelectMode
      //   ? selectedTemplateIds.includes(template._id)
      //   : template._id === selectedId,
      selected: false,
    }));

    setState((prev) => ({
      ...prev,
      listData: updatedList,
    }));
  }, [rawApiData, selectedTemplateIds, selectedId, isMultiSelectMode]);

  // const onTemplateSelect = (selectedTemplateId: string) => {
  //   if (!isMultiSelectMode) {
  //     const updatedList = state.listData.map((item) => ({
  //       ...item,
  //       selected: item._id === selectedTemplateId,
  //     }));
  //     setState((prev) => ({
  //       ...prev,
  //       listData: updatedList,
  //     }));
  //   }
  // };

  const onTemplateSelect = (item: any) => {
    // if (item.selected) return;
    if (!isMultiSelectMode) {
      setPendingSelection(item);
      setShowConfirmModal(true);
    }
  };

  const handleConfirmMasterDesign = async () => {
    try {
      const payload: any = {
        post_type: type,
        design_record_id: pendingSelection._id,
      };

      const res = await TemplatesApi.setTemplate(payload);

      if (res?.data?.success) {
        const updatedList = state.listData.map((item) => ({
          ...item,
          selected: item._id === pendingSelection._id,
        }));

        setState((prev) => ({
          ...prev,
          listData: updatedList,
        }));

        toast.success("Master design updated!");
        setShowConfirmModal(false);
      } else {
        toast.error(res?.data?.message || "Something went wrong!");
      }
    } catch (error) {
      console.error(error);
      toast.error("Error updating master design");
    }
  };

  const handleCardClick = (data: any) => {
    const mediaPath = checkVideo(data.post_type)
      ? data?.template_video_ref?.compressed_file_path
      : data?.template_image_ref?.compressed_file_path;

    if (mediaPath) {
      setPreviewImages([getImageUrl(mediaPath)]);
      setPreviewOpen(true);
    }
  };

  return (
    <div className="standard-templates-list-container">
      {state?.isLoading ? (
        <div className="list-page-loading">
          <Loading />
        </div>
      ) : state?.listData?.length === 0 ? (
        <div className="data-not-found">
          <p>Templates not found !</p>
        </div>
      ) : (
        <div className="select-template-container">
          {state?.listData?.map((data: any) => (
            <div className="template-card-wrapper" key={data?._id}>
              <div className="template-header-bar">
                <p className="template-name">{data?.name}</p>
                <button
                  className={`select-btn ${data.selected ? "selected" : ""}`}
                  onClick={() => onTemplateSelect(data)}
                >
                  {data.selected ? "Selected" : "Select"}
                </button>
              </div>

              <div className="template-preview-row">
                <div className="post-column">
                  <div className="image-post-box">
                    <img
                      src={getImageUrl(
                        data?.image_post_master_design_svg_file
                          ?.original_file_path,
                      )}
                      alt="Image Post"
                    />
                  </div>
                  <div className="post-footer">
                    <span>Image Post</span>
                    <div className="footer-icons">
                      <DownloadIcon />
                      <PreviewCircleIcon />
                    </div>
                  </div>
                </div>

                <div className="post-column">
                  <div className="story-post-box">
                    <div className="story-inner-img">
                      <img
                        src={getImageUrl(
                          data?.story_post_master_design_svg_file
                            ?.original_file_path,
                        )}
                        alt="Story Post"
                      />
                    </div>
                  </div>
                  <div className="post-footer">
                    <span>Story Post</span>
                    <div className="footer-icons">
                      <DownloadIcon />
                      <PreviewCircleIcon />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {showConfirmModal && (
        <Modal
          open={showConfirmModal}
          onClose={() => setShowConfirmModal(false)}
          className="master-design-modal-wrapper"
        >
          <div className="master-confirm-container">
            <h3>Set as Master Design?</h3>
            <p className="modal-subtitle">
              All future marketing assets will be generated based on this master
              design setup. You can customize these designs at any time after
              confirmation.
            </p>

            <div className="modal-preview-section">
              <div className="template-header-bar mini">
                <p className="template-name">{pendingSelection?.name}</p>
              </div>

              <div className="template-preview-row">
                <div className="post-column">
                  <div className="image-post-box">
                    <img
                      src={getImageUrl(
                        pendingSelection?.image_post_master_design_svg_file
                          ?.original_file_path,
                      )}
                      alt="Preview"
                    />
                  </div>
                  <div className="post-footer">
                    <span>Image Post</span>
                    <div className="footer-icons">
                      <DownloadIcon />
                      <PreviewCircleIcon />
                    </div>
                  </div>
                </div>

                <div className="post-column">
                  <div className="story-post-box">
                    <div className="story-inner-img">
                      <img
                        src={getImageUrl(
                          pendingSelection?.story_post_master_design_svg_file
                            ?.original_file_path,
                        )}
                        alt="Preview"
                      />
                    </div>
                  </div>
                  <div className="post-footer">
                    <span>Story Post</span>
                    <div className="footer-icons">
                      <DownloadIcon />
                      <PreviewCircleIcon />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <p className="final-confirmation-text">
              Would you like to set this as the master design?
            </p>

            <div className="modal-action-btns">
              <button
                className="btn-cancel"
                onClick={() => setShowConfirmModal(false)}
              >
                Cancel
              </button>
              <button
                className="btn-confirm"
                onClick={handleConfirmMasterDesign}
              >
                Confirm
              </button>
            </div>
          </div>
        </Modal>
      )}

      {state?.totalPage !== 1 && (
        <div className="template-list-pagination">
          <button
            className="preview-box pagination-button"
            onClick={onClickPreview}
            disabled={state?.pageNumber === 1 ? true : false}
          >
            <LeftArrowIcon />
          </button>
          <div className="pagination-page-no">
            <p>
              Page {state?.pageNumber} of {state.totalPage}
            </p>
          </div>
          <button
            className="next-box pagination-button"
            onClick={onClickNext}
            disabled={state?.pageNumber === state.totalPage ? true : false}
          >
            <RightArrowIcon />
          </button>
        </div>
      )}

      <PreviewModal
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
        images={previewImages}
      />
    </div>
  );
};

export default AgencyPersonalizedTemplatesList;
